import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Company from "@/pages/Company";
import Platform from "@/pages/Platform";
import Projects from "@/pages/Projects";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";
import Demo from "@/pages/Demo";

export default function App() {
  return (
    <>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="company" element={<Company />} />
              <Route path="platform" element={<Platform />} />
              <Route path="projects" element={<Projects />} />

              <Route path="demo" element={<Demo />} />

              <Route path="contact" element={<Contact />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </>
  );
}